import React from 'react';
import ConditionQuestionComponent from 'dashboard/processing/ConditionQuestionComponent';
import ConditionMultipleChoiceComponent from 'dashboard/processing/ConditionMultipleChoiceComponent';
import ConditionDetailsInput from 'dashboard/processing/components/ConditionDetailsInput';
import QualityCheckNavigation from 'dashboard/processing/components/QualityCheckNavigation';
import ConditionSerialNumberComponent from '../ConditionSerialNumberComponent';

const QualityCheckList = (props) => {
  const {
    screensData = {},
    featureFlags: {
      EnableSerialNumberQC: enableSerialNumberQC = false } = {}
  } = props;
  const { currentQualityCheckRecord = {} } = screensData;
  const { DeterministicQualityCheck = {}, IsSerialNumber = false } = currentQualityCheckRecord;
  const { Answers = [], Choices = [] } = DeterministicQualityCheck;
  const foundItemIndex = screensData.qualityCheckItems.findIndex((qualityCheckItem) => {
    return currentQualityCheckRecord._id == qualityCheckItem._id;
  });

  if (foundItemIndex == -1) {
    return null;
  }

  let showSerialNumberComponent = false;
  let showMultipleChoiseComponent = false;
  let showQuestionComponent = false;

  if (enableSerialNumberQC && IsSerialNumber) {
    showSerialNumberComponent = true;
  } else {
    showQuestionComponent = (Choices.length == 0 && Answers.length > 0);
    showMultipleChoiseComponent = (Choices.length > 0);
  }

  return (
    <div
      style={{
        marginTop: 15,
        marginBottom: 30,
      }}
    >
      <div style={{ marginTop: 15 }}>
        {showSerialNumberComponent && (
          <ConditionSerialNumberComponent
            qualityCheckRecord={currentQualityCheckRecord}
            screensData={props.screensData}
            onChange={(text) => props.setScreensData({
              SerialNumber: text
            })}
            qualityCheckAnswerHandler={(data) => props.qualityCheckAnswerHandler({ foundItemIndex, ...data })}
          ></ConditionSerialNumberComponent>
        )}
        {showQuestionComponent && (
          <ConditionQuestionComponent
            qualityCheckRecord={currentQualityCheckRecord}
            foundItemIndex={foundItemIndex}
            displayCustomInputs={() => <ConditionDetailsInput {...props}></ConditionDetailsInput>}
            qualityCheckAnswerHandler={(data) => {
              props.qualityCheckAnswerHandler({ foundItemIndex, ...data });
            }}
          ></ConditionQuestionComponent>
        )}
        {showMultipleChoiseComponent && (
          <ConditionMultipleChoiceComponent
            qualityCheckRecord={currentQualityCheckRecord}
            screensData={props.screensData}
            updateDetailsText={(text) => props.setScreensData({
              Details: text
            })}
            displayCustomInputs={() => <ConditionDetailsInput {...props}></ConditionDetailsInput>}
            qualityCheckAnswerHandler={(data) => props.qualityCheckAnswerHandler({ foundItemIndex, ...data })}
          ></ConditionMultipleChoiceComponent>
        )}
      </div>
      <QualityCheckNavigation {...props}></QualityCheckNavigation>
    </div>
  );
};

export default QualityCheckList;
